module.exports = __webpack_public_path__ + "img/wizard-01.5dde51c8.png";